[
  {
    "code": "linkedin",
    "label": {
      "en": "LinkedIn"
    },
    "order": 1,
    "is_active": true,
    "metadata": {
      "icon": "mdi:linkedin",
      "base_url": "https://linkedin.com/in/",
      "placeholder": "username"
    }
  },
  {
    "code": "twitter",
    "label": {
      "en": "X (Twitter)"
    },
    "order": 2,
    "is_active": true,
    "metadata": {
      "icon": "mdi:twitter",
      "base_url": "https://x.com/",
      "placeholder": "@username"
    }
  },
  {
    "code": "github",
    "label": {
      "en": "GitHub"
    },
    "order": 3,
    "is_active": true,
    "metadata": {
      "icon": "mdi:github",
      "base_url": "https://github.com/",
      "placeholder": "username"
    }
  },
  {
    "code": "instagram",
    "label": {
      "en": "Instagram"
    },
    "order": 4,
    "is_active": true,
    "metadata": {
      "icon": "mdi:instagram",
      "base_url": "https://instagram.com/",
      "placeholder": "@username"
    }
  },
  {
    "code": "facebook",
    "label": {
      "en": "Facebook"
    },
    "order": 5,
    "is_active": true,
    "metadata": {
      "icon": "mdi:facebook",
      "base_url": "https://facebook.com/",
      "placeholder": "username"
    }
  },
  {
    "code": "youtube",
    "label": {
      "en": "YouTube"
    },
    "order": 6,
    "is_active": true,
    "metadata": {
      "icon": "mdi:youtube",
      "base_url": "https://youtube.com/@",
      "placeholder": "@channel"
    }
  },
  {
    "code": "tiktok",
    "label": {
      "en": "TikTok"
    },
    "order": 7,
    "is_active": true,
    "metadata": {
      "icon": "mdi:music-note",
      "base_url": "https://tiktok.com/@",
      "placeholder": "@username"
    }
  },
  {
    "code": "whatsapp",
    "label": {
      "en": "WhatsApp"
    },
    "order": 8,
    "is_active": true,
    "metadata": {
      "icon": "mdi:whatsapp",
      "base_url": "https://wa.me/",
      "placeholder": "+34600000000"
    }
  },
  {
    "code": "telegram",
    "label": {
      "en": "Telegram"
    },
    "order": 9,
    "is_active": true,
    "metadata": {
      "icon": "mdi:telegram",
      "base_url": "https://t.me/",
      "placeholder": "@username"
    }
  },
  {
    "code": "discord",
    "label": {
      "en": "Discord"
    },
    "order": 10,
    "is_active": true,
    "metadata": {
      "icon": "mdi:discord",
      "base_url": null,
      "placeholder": "username#0000"
    }
  },
  {
    "code": "slack",
    "label": {
      "en": "Slack"
    },
    "order": 11,
    "is_active": true,
    "metadata": {
      "icon": "mdi:slack",
      "base_url": null,
      "placeholder": "workspace"
    }
  },
  {
    "code": "pinterest",
    "label": {
      "en": "Pinterest"
    },
    "order": 12,
    "is_active": true,
    "metadata": {
      "icon": "mdi:pinterest",
      "base_url": "https://pinterest.com/",
      "placeholder": "username"
    }
  },
  {
    "code": "reddit",
    "label": {
      "en": "Reddit"
    },
    "order": 13,
    "is_active": true,
    "metadata": {
      "icon": "mdi:reddit",
      "base_url": "https://reddit.com/user/",
      "placeholder": "u/username"
    }
  },
  {
    "code": "twitch",
    "label": {
      "en": "Twitch"
    },
    "order": 14,
    "is_active": true,
    "metadata": {
      "icon": "mdi:twitch",
      "base_url": "https://twitch.tv/",
      "placeholder": "username"
    }
  },
  {
    "code": "bereal",
    "label": {
      "en": "BeReal"
    },
    "order": 15,
    "is_active": true,
    "metadata": {
      "icon": "mdi:camera",
      "base_url": null,
      "placeholder": "username"
    }
  }
]
